import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);    
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kodecash', 'namacash'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/cashflowacc${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function update(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const obj = {kodelama: data.kodelama,  kodecash: data.kodecash, namacash: data.namacash, jenis: data.jenis } ;
            await axios.put("cashflowacc", obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function insert(data) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("cashflowacc", data);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`cashflowacc/${obj.kodecash}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
function print(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodecash', 'namacash'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/cashflowacc/printreport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'cashflowacc.pdf');
                document.body.appendChild(link);
                link.click();
                resolve(url);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
        });

    }

function exportXls(obj = {}) {
    const keys = ['sortBy', 'sortDir', 'kodecash', 'namacash'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/cashflowacc/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cashflowacc.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
        
}

export default { list, insert, update, remove, print, exportXls };